/**
 * @description
 * 路径跳转、刷新
 */

import * as config from "../config"
import { createNamespacedHelpers } from "vuex-composition-helpers"
import { AppleGiftCardGetters } from "../store/apple-gift-card/getters"
import { AppleGiftCardMutations } from "../store/apple-gift-card/mutations"
import { AppleGiftCardState } from "../store/apple-gift-card/state"
import { AppleGiftCardActions } from "../store/apple-gift-card/actions"

const { useActions, useState } = createNamespacedHelpers<
  AppleGiftCardState,
  AppleGiftCardGetters,
  AppleGiftCardActions,
  AppleGiftCardMutations
>("appleGiftCard")
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => {
  const { configInfo, usingLocation } = useState(["configInfo", "usingLocation"])
  const { reportUserAction } = useActions(["reportUserAction"])
  const checkHelpGuide = (): void => {
    location.href = "//pay.qq.com/h5/activity/applegiftcardpolicy.php"
  }
  const goCustomerSevice = (): void => {
    reportUserAction({
      iformat: config.REPORT.CLICK.CUSTOMER_SERVICE
    })
    location.href = configInfo.value.customerService
  }
  const goBanner = (url: string): void => {
    reportUserAction({
      iformat: config.REPORT.CLICK.BANNER
    })
    if (url) {
      location.href = url
    }
  }
  const reload = () => {
    location.reload()
  }
  const toRechargePage = (report?: boolean) => {
    report &&
      reportUserAction({
        iformat: config.REPORT.CLICK[usingLocation.value].ZONE // 去专区按钮上报
      })
    location.href = "//pay.qq.com/h5/store/apple-gift-card.shtml?pf=__mds_hp_applestore"
  }

  return {
    checkHelpGuide,
    goCustomerSevice,
    goBanner,
    reload,
    toRechargePage
  }
}
